<template>
    <v-card>
        <v-card-title>
            <v-row>
                <v-col cols="12" md="6">
                    Renters List
                </v-col>
                <v-col cols="12" md="6" class="text-right">
                    <v-btn color="primary" @click="editReservee()" class="mr-3">Add</v-btn>
                    <template v-if="!$store.state.model.reservation.group_link_id && do_not_show_price_on_checkout!=1 && !($store.state.model.reservation._type=='advance' && !$store.state.model.reservation.is_seasonal && no_priceing_checkouts==1)">
                        <v-btn @click="ui__openModalByName({name:'dialog_rental_rates'})">See prices</v-btn>
                    </template>
                </v-col>
            </v-row>
        </v-card-title>
        <v-list three-line>
            <v-divider class="m-0"></v-divider>
            <v-list-item v-if="reservees.filter(r => r.full_name).length === 0">
                <v-alert dense text type="info" class="w-100">
                    <a href="#" @click.prevent="editReservee()">You can click here to add a renter.</a>
                </v-alert>
            </v-list-item>
            <template v-for="reservee in reservees.filter(r => r.full_name)">
                <v-list-item :key="'list_item_'+reservee._id">
                    <v-list-item-avatar>
                        <v-icon
                            class="grey lighten-1"
                            dark
                        >
                            mdi-ski
                        </v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title v-text="reservee.full_name"></v-list-item-title>

                        <v-list-item-subtitle v-text="reserveeSubtitle(reservee)"></v-list-item-subtitle>
                        <v-list-item-subtitle v-text="reserveeSubtitle2(reservee)"></v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                        <v-btn icon @click="editReservee(reservee)">
                            <v-icon color="primary">mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn icon @click="deleteReservee(reservee, false)">
                            <v-icon color="error">mdi-delete</v-icon>
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
                <v-divider :key="'divider_'+reservee._id"></v-divider>
            </template>

        </v-list>
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card v-if="currentEditReservee">
                <v-card-title class="text-h5">Are you sure you want to delete {{ currentEditReservee.full_name }}?
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogDelete = false">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteReservee(currentEditReservee,true)">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import moment         from "moment";
import UiManagerMixin from "../../mixins/UiManagerMixin";
import ReserveeModel  from "../../models/ReserveeModel";
import {mapGetters} from "vuex";

export default {
    name    : "RentersSimpleList",
    mixins  : [UiManagerMixin],
    data    : () => ({
        editModalId : null,
        dialogDelete: false,
        hasSkip     : false,
        editId      : ""
    }),
    computed: {
        reservees() {
            return this.$store.state.model.reservees;
        },
        currentEditReservee() {
            return this.reservees.find(r => r._id === this.editId);
        },
        currentStep() {
            return this.$store.state.currentStepId;
        },

        skip_rates(){
            return parseInt(this.$store.state.resources.config.skip_rates);
        },
        skip_rates_kiosk(){
            return parseInt(this.$store.state.resources.config.skip_rates_kiosk);
        },
        return_customer_kiosk() {
            return parseInt(this.$store.state.resources.config.return_customer_kiosk);
        },
        multi_day_is_enabled() {
            return parseInt(this.$store.state.resources.config.multi_day_is_enabled);
        },
        multi_day_start_after() {
            return parseInt(this.$store.state.resources.config.multi_day_start_after);
        },
        frontend_view_folder() {
            return this.$store.state.resources.config.frontend_view_folder;
        },
        no_priceing_checkouts() {
            return this.$store.state.resources.config.no_priceing_checkouts;
        },
        module_type_enabled(){
            return this.$store.state.resources.config.module_type_enabled;
        },
        module_type(){
            return this.$store.state.resources.config.module_type;
        },
        config(){
            return this.$store.state.config;
        },
        is_holiday_or_weekend() {
            let day = this.$store.state.model.reservation.date_pickup;
            let is_holiday_or_week_day = false;
            if(this.$store.state.resources.config.holidays!==null){
                for (const [key, value] of Object.entries(this.$store.state.resources.config.holidays)) {
                    if(value.start!==null && value.end!==null) {
                        is_holiday_or_week_day = moment(day, 'YYYY-MM-DD').isBetween(moment(value.start, 'MM/DD/YYYY'), moment(value.end, 'MM/DD/YYYY'), null, '[]');
                        if (is_holiday_or_week_day) break;
                    }
                }
            }
            let is_weekend = moment(day).isoWeekday()==5 || moment(day).isoWeekday()==6;
            return is_weekend || is_holiday_or_week_day;
        },
        ...mapGetters(['return_customer', 'is_watched_rental_details', 'is_in_special_period', 'special_period_increase', 'book_me_host_code', 'do_not_show_price_on_checkout'])
    },
    watch   : {
        currentStep(newVal, oldVal) {
            let old_val = 2;
            let new_val = 3;
            if(this.return_customer_kiosk && this.$store.state.model.reservation.is_from_kiosk){
                old_val = 3;
                new_val = 4;
            }
            if (oldVal == old_val && newVal == new_val) {
                this.openNextEmpty();
            }
        },
        "$store.state.is_watched_rental_details": function (val) {
            if(val && ((!this.skip_rates && !this.$store.state.model.reservation.is_from_kiosk) || (!this.skip_rates_kiosk && this.$store.state.model.reservation.is_from_kiosk))){
                if (this.$store.state.model.reservees.length) {
                    let filtered = this.$store.state.model.reservees.filter(r => r.full_name);

                    if (filtered.length) {
                        // if (filtered.length !== 1) {
                        //     let return_customer_index = filtered.findIndex(r => (r.full_name.toLowerCase() === this.return_customer.full_name.toLowerCase()) && (r.dob === this.return_customer.dob));
                        //     let return_customer_in_array = filtered[return_customer_index];
                        //     filtered.splice(return_customer_index, 1);
                        //     filtered.push(return_customer_in_array);
                        // }
                        filtered.forEach((element, index) => this.editReservee(element));
                    } else {
                        this.openNextEmpty();
                    }
                } else {
                    this.openNextEmpty();
                }
            }
        }
    },
    methods : {
        openNextEmpty() {
            let emptyReservee = this.$store.state.model.reservees.find(r => !r.full_name);
            if (emptyReservee) {
                this.$nextTick(() => {
                    this.editReservee(emptyReservee, true);
                });
            }
        },
        reserveeSubtitle(reservee) {
            const bDay = moment(reservee.dob);
            const age = moment().diff(bDay, 'years');
            return `${reservee.gender}, ${age} y.o.`
        },
        reserveeSubtitle2(reservee) {
            const packageName = this.packageText(reservee);
            const skierType = reservee.skier_type ? this.skierTypeById(reservee.skier_type).title : '';
            return `${skierType} | ${packageName}`
        },
        skierTypeById(id) {
            return this.$store.state.resources.skier_types.find(s => s.id == id);
        },
        packageById(id) {
            return this.$store.state.resources.packages.find(p => p.id === id);
        },
        packageText(item) {
            const pkg = this.packageById(item.package_id);
            const days = moment(this.$store.state.model.reservation.date_return).diff(moment(this.$store.state.model.reservation.date_pickup), 'days') + 1;
            let pkg_price = "";
            if(this.do_not_show_price_on_checkout!=1 && !(this.$store.state.model.reservation._type=='advance' && !this.$store.state.model.reservation.is_seasonal && this.no_priceing_checkouts==1)) {
                if (this.$store.state.resources.config.frontend_view_folder == 'frontend.skigd') {
                    pkg_price = ((this.$store.state.model.reservation._type == 'kiosk' && this.$store.state.model.reservation.single_day_type == 'afternoon') ? pkg.half_day_rate : (this.$store.state.model.reservation.single_day_type == 'night' ? pkg.night_rate : pkg.current_rate));

                }
                else if(this.$store.state.model.reservation.is_prepay){
                    pkg_price = (this.$store.state.resources.config.is_prepay_discount=="1" && this.$store.state.resources.config.prepay_discount!="0") ? pkg.current_rate + ' (-'+this.$store.state.resources.config.prepay_discount+'%)': pkg.current_rate;
                }
                else if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_12'){
                    if(this.$store.state.model.reservation._type == 'advance'){
                        if(this.$store.state.model.reservation.single_day_type=='multiday'){
                            pkg_price = pkg.current_rate ;
                            // pkg_price = ((days == 2 )?pkg.day_2_Rate: (days == 3) ?pkg.day_3_Rate:(days == 4)?pkg.day_4_Rate:(days == 5)?pkg.day_5_Rate:(days > 5)?pkg.additional_day_rate:pkg.current_rate );
                        }else{
                            pkg_price = ((this.$store.state.model.reservation._type == 'advance' && this.$store.state.model.reservation.single_day_type=='afternoon')?pkg.halfDayRate: this.$store.state.model.reservation.single_day_type=='morning'?pkg.morningRate:this.$store.state.model.reservation.single_day_type=='twilight'?pkg.twilightRate:this.$store.state.model.reservation.single_day_type=='beech_pass'?pkg.beechPassRate:(this.$store.state.model.reservation.single_day_type=='night'?pkg.nightRate:pkg.current_rate )) ;
                        }
                    }else{
                        pkg_price = pkg.current_rate;
                    }
                }
                else if(this.$store.state.resources.config.delivery == 1 && window.location.href.includes('delivery')){
                    pkg_price = pkg.current_rate;
                }
                else if(this.module_type_enabled != 0 && this.module_type == 'module_7'){
                    pkg_price = ((this.multi_day_is_enabled && days>this.multi_day_start_after && this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(pkg.multi_day_rate.replace('$', ''))+((parseFloat(pkg.multi_day_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):(days>this.multi_day_start_after && days<7 && !this.$store.state.model.reservation.is_seasonal)?pkg.multi_day_rate:(days>this.multi_day_start_after && days>=7 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_7_plus: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(pkg.current_rate.replace('$', ''))+((parseFloat(pkg.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):pkg.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'');
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_5'){
                    if(window.location.hostname == 'rentals.alpenhausonline.com'){
                        pkg_price = ((days>5 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_6_rate:(days==5 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_5_rate:(days==4 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_4_rate:(days==3 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_3_rate:(days==2 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_2_rate: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(pkg.current_rate.replace('$', ''))+((parseFloat(pkg.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):pkg.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'');
                    }else{
                        pkg_price = (
                            (this.$store.state.resources.config.frontend_view_folder == "frontend.winterpark" && days > 8 && !this.$store.state.model.reservation.is_seasonal)
                                ? pkg.day_9_rate :
                            (this.$store.state.resources.config.frontend_view_folder == "frontend.winterpark" && days > 7 && !this.$store.state.model.reservation.is_seasonal)
                                ? pkg.day_8_rate :
                            (days > 6 && !this.$store.state.model.reservation.is_seasonal)
                                ? pkg.day_7_rate :
                            (days == 6 && !this.$store.state.model.reservation.is_seasonal)
                                ? pkg.day_6_rate :
                            (days == 5 && !this.$store.state.model.reservation.is_seasonal)
                                ? pkg.day_5_rate :
                            (days == 4 && !this.$store.state.model.reservation.is_seasonal)
                                ? pkg.day_4_rate :
                            (days == 3 && !this.$store.state.model.reservation.is_seasonal)
                                ? pkg.day_3_rate :
                            (days == 2 && !this.$store.state.model.reservation.is_seasonal)
                                ? pkg.day_2_rate :
                            (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)
                                ? "$" + ((parseFloat(pkg.current_rate.replace('$', '')) +
                                          ((parseFloat(pkg.current_rate.replace('$', '')) * this.special_period_increase) / 100)).toFixed(2))
                                : pkg.current_rate
                        ) +
                        (((this.discount_type == "percentage" && this.discount !== 0) &&
                           !parseInt(this.$store.state.model.reservation.is_from_kiosk))
                           ? ' (-' + this.discount + '%)' : '');
                    }
                } else if(this.module_type_enabled != 0 && this.module_type == 'module_5_1'){
                    pkg_price = ((days>2 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_3_rate:(days==2 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_2_rate: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(pkg.current_rate.replace('$', ''))+((parseFloat(pkg.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):pkg.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'');
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_5_2'){
                    if(this.$store.state.model.reservation.single_day_type=='afternoon'){
                        pkg_price = pkg.half_day_rate;
                    }else{
                        pkg_price = ((days>6 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_7_rate:(days==6 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_6_rate:(days==5 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_5_rate:(days==4 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_4_rate:(days==3 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_3_rate:(days==2 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_2_rate: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(pkg.current_rate.replace('$', ''))+((parseFloat(pkg.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):pkg.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'');
                    }
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_5_3'){
                    if(this.$store.state.model.reservation.single_day_type=='afternoon'){
                        pkg_price = pkg.half_day_rate;
                    }else{
                        pkg_price = ((this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(pkg.current_rate.replace('$', ''))+((parseFloat(pkg.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):pkg.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'');
                    }
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_9') {
                    pkg_price = (this.$store.state.model.reservation.is_seasonal ? pkg.current_rate : (days > 1 && days < 4) ? pkg.day2_rate : (days >= 4) ? pkg.day_4_plus : this.$store.state.model.reservation.single_day_type == 'afternoon' ? pkg.half_day_rate : this.$store.state.model.reservation.single_day_type == 'night' ? pkg.night_rate : (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal) ? "$" + ((parseFloat(pkg.current_rate.replace('$', '')) + ((parseFloat(pkg.current_rate.replace('$', '')) * this.special_period_increase) / 100))).toFixed(2) : pkg.current_rate) + (((this.discount_type == "percentage" && this.discount !== 0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk)) ? ' (-' + this.discount + '%)' : '');
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_10') {
                    pkg_price = (this.$store.state.model.reservation.is_seasonal ? pkg.current_rate : (days == 2 ) ? pkg.day2_rate : (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal) ? "$" + ((parseFloat(pkg.current_rate.replace('$', '')) + ((parseFloat(pkg.current_rate.replace('$', '')) * this.special_period_increase) / 100))).toFixed(2) : pkg.current_rate) + (((this.discount_type == "percentage" && this.discount !== 0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk)) ? ' (-' + this.discount + '%)' : '');
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_11') {
                    pkg_price = (this.$store.state.model.reservation.is_seasonal ? pkg.current_rate : (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal) ? "$" + ((parseFloat(pkg.current_rate.replace('$', '')) + ((parseFloat(pkg.current_rate.replace('$', '')) * this.special_period_increase) / 100))).toFixed(2) : pkg.current_rate) + (((this.discount_type == "percentage" && this.discount !== 0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk)) ? ' (-' + this.discount + '%)' : '');
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_13') {
                    pkg_price = ((days>5 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_6_plus:(days>1  && !this.$store.state.model.reservation.is_seasonal)?pkg.day2_5: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(pkg.current_rate.replace('$', ''))+((parseFloat(pkg.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):pkg.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'');
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_14') {
                    pkg_price = ((days>3 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_4_plus:(days>1  && !this.$store.state.model.reservation.is_seasonal)?pkg.day2_rate: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(pkg.current_rate.replace('$', ''))+((parseFloat(pkg.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):pkg.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'');
                }
                else if(this.module_type_enabled != 0 && this.module_type == 'module_16') {
                    pkg_price = ((days>4 && !this.$store.state.model.reservation.is_seasonal)?pkg.day_5_rate:(days>2  && !this.$store.state.model.reservation.is_seasonal)?pkg.day3_4_rate:(days==2  && !this.$store.state.model.reservation.is_seasonal)?pkg.day2_rate: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(pkg.current_rate.replace('$', ''))+((parseFloat(pkg.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):pkg.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'');
                }
                else if(this.module_type_enabled != 0 && this.module_type == 'module_17') {
                    pkg_price = ((this.$store.state.model.reservation._type == 'kiosk' && this.$store.state.model.reservation.single_day_type=='afternoon')?pkg.half_day_rate: (this.$store.state.model.reservation.single_day_type=='night'?pkg.night_rate:(this.multi_day_is_enabled && days>this.multi_day_start_after && !this.$store.state.model.reservation.is_seasonal)?pkg.multi_day_rate:pkg.current_rate ));    
                }else if(this.module_type_enabled != 0 && this.module_type == 'module_18') {
                    pkg_price = ( this.$store.state.model.reservation.single_day_type=='night'?pkg.night_rate: (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal)?"$" + ((parseFloat(pkg.current_rate.replace('$', ''))+((parseFloat(pkg.current_rate.replace('$', ''))*this.special_period_increase)/100))).toFixed(2):pkg.current_rate ) + (((this.discount_type=="percentage" && this.discount!==0) && !parseInt(this.$store.state.model.reservation.is_from_kiosk))?' (-'+this.discount+'%)':'');
                }
                else {
                    pkg_price = (this.multi_day_is_enabled && days > this.multi_day_start_after && this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal) ? "$" + ((parseFloat(pkg.multi_day_rate.replace('$', '')) + ((parseFloat(pkg.multi_day_rate.replace('$', '')) * this.special_period_increase) / 100))).toFixed(2) : (this.multi_day_is_enabled && days > this.multi_day_start_after) ? pkg.multi_day_rate : this.$store.state.model.reservation.single_day_type == 'day_hours' && this.is_holiday_or_weekend ? pkg.weekends_and_holiday : this.$store.state.model.reservation.single_day_type == 'day_hours' && !this.is_holiday_or_weekend ? pkg.week_days_non_holiday : this.$store.state.model.reservation.single_day_type == 'night_hours' ? pkg.night_hours : (this.is_in_special_period && !this.$store.state.model.reservation.is_seasonal) ? "$" + ((parseFloat(pkg.current_rate.replace('$', '')) + ((parseFloat(pkg.current_rate.replace('$', '')) * this.special_period_increase) / 100))).toFixed(2) : pkg.current_rate;
                }
            }
            return pkg ? (pkg.title + ((!this.$store.state.model.reservation.group_link_id && this.do_not_show_price_on_checkout!=1 && !(this.$store.state.model.reservation._type=='advance' && !this.$store.state.model.reservation.is_seasonal && this.no_priceing_checkouts==1))?' (' + pkg_price + ')':"")) : 'Loading...';

        },
        deleteReservee(reservee, force) {
            if (!force) {
                this.editId = reservee._id;
                this.dialogDelete = true;
            } else {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.$store.commit('reservee_delete', this.editId);
                this.dialogDelete = false;
                this.editId = "";
            }
            if(window.location.href.includes('prepay')){
                this.calcualte_prepay_total();
            }
        },
        calcualte_prepay_total() {
            if(this.$store.state.model.reservation._type=='kiosk'){
                let sales_tax = 0;
                if(this.$store.state.resources.config.sales_tax_switch=="1"){
                    let tax = this.$store.state.resources.config.sales_tax;
                    if(this.is_international_canadian){
                        tax = parseFloat(this.$store.state.resources.config.sales_tax_pst) + parseFloat(this.$store.state.resources.config.sales_tax_gst);
                    }
                    sales_tax = ((+this.$store.state.model.reservation.prepay_total_packages_price)*(+tax))/100;
                }

                let total = (this.$store.state.model.reservation.prepay_total_packages_price + parseFloat(sales_tax)).toFixed(2);
                this.$store.commit('set_prepay_total_packages_price', total);

            }else{
                let prepay_total_packages_price = this.$store.state.model.reservation.prepay_total_packages_price;
                let sales_tax = 0;
                if(this.$store.state.resources.config.sales_tax_switch=="1"){
                    let tax = this.$store.state.resources.config.sales_tax;
                    if(this.is_international_canadian){
                        tax = parseFloat(this.$store.state.resources.config.sales_tax_pst) + parseFloat(this.$store.state.resources.config.sales_tax_gst);
                    }
                    sales_tax = ((+this.$store.state.model.reservation.prepay_total_packages_price)*(+tax))/100;
                }
                let fee = 0;
                if(parseInt(this.$store.state.resources.config.special_fee_at_checkout) == 1){
                    if(this.$store.state.resources.config.special_fee_type == "percentage"){
                        fee = (this.$store.state.resources.config.special_fixed_fee * prepay_total_packages_price)/100;
                    }else{
                        fee =  this.$store.state.model.reservees.length * this.$store.state.resources.config.special_fixed_fee;
                    }
                }
                prepay_total_packages_price = prepay_total_packages_price + parseFloat(sales_tax);

                prepay_total_packages_price = prepay_total_packages_price + parseFloat(fee);
                this.$store.commit('set_prepay_total_packages_price', prepay_total_packages_price.toFixed(2));
            }

        },
        editReservee(reservee) {
            reservee = reservee || new ReserveeModel();
            this.editId = reservee._id;
            const payload = {name: 'dialog_reservee_form'};
            payload.data = {
                model: {
                    applyDefaultAddon: reservee.weight == null ? true : reservee.weight.length == 0,
                    model: reservee,
                    next : this.openNextEmpty.bind(this)
                }
            };

            this.ui__openModalByName(payload);
        }
    },
    mounted() {
        console.log(this.reservees.filter(r => r.full_name).length, this.reservees.filter(r => r.full_name));
        if(!this.$store.state.model.reservation.group_link_id && ((!this.skip_rates && !this.$store.state.model.reservation.is_from_kiosk) || (!this.skip_rates_kiosk && this.$store.state.model.reservation.is_from_kiosk)) && (!window.location.href.includes('prepay')) && (this.do_not_show_price_on_checkout!=1 && !(this.$store.state.model.reservation._type=='advance' && !this.$store.state.model.reservation.is_seasonal && this.no_priceing_checkouts==1))){
            this.ui__openModalByName({name:'dialog_show_packages_rate'});
        }
        if(this.$store.state.model.reservation.group_link_id || (this.do_not_show_price_on_checkout==1 || (this.$store.state.model.reservation._type=='advance' && !this.$store.state.model.reservation.is_seasonal && this.no_priceing_checkouts==1)) || (this.$store.state.model.reservation.is_from_kiosk && (this.skip_rates_kiosk || (!this.skip_rates_kiosk && this.is_watched_rental_details))) || (!this.$store.state.model.reservation.is_from_kiosk && (this.skip_rates || (!this.skip_rates && this.is_watched_rental_details)))){
            if (this.$store.state.model.reservees.length) {
                let filtered = this.$store.state.model.reservees.filter(r => r.full_name);

                if (filtered.length) {
                    // if (filtered.length !== 1) {
                    //     let return_customer_index = filtered.findIndex(r => (r.full_name.toLowerCase() === this.return_customer.full_name.toLowerCase()) && (r.dob === this.return_customer.dob));
                    //     let return_customer_in_array = filtered[return_customer_index];
                    //     filtered.splice(return_customer_index, 1);
                    //     filtered.push(return_customer_in_array);
                    // }
                    filtered.forEach((element, index) => this.editReservee(element));
                } else {
                    this.openNextEmpty();
                }
            } else {
                this.openNextEmpty();
            }
        }
    }
}
</script>

<style scoped>

</style>
